import { useEffect } from 'react'

import { useToast } from '@twistopayments/design-system/components/atoms/toast'
import { useSetAtom } from 'jotai'

import { DEV_ANALYTICS_CUSTOM_EVENT } from '@twisto/utils'

import { devAnalyticsLogsAtom } from './dev-analytics-atoms'
import { DevAnalyticsToastContent } from './dev-analytics-toast-content'

const MAX_LOGS = 100

type DevAnalyticsEventDetail = {
  name: string
  parameters: Record<string, unknown> | null
}

export const DevAnalyticsListener = () => {
  const { showToast } = useToast()
  const setLogs = useSetAtom(devAnalyticsLogsAtom)

  useEffect(() => {
    const listenToDevAnalyticsEvents = (e: Event) => {
      const { name, parameters } = (e as CustomEvent<DevAnalyticsEventDetail>)
        .detail

      setLogs((prev) =>
        [...prev, { name, parameters, id: Date.now() }].slice(-MAX_LOGS)
      )

      showToast({
        message: (
          <DevAnalyticsToastContent
            eventName={name}
            parameters={parameters ?? null}
          />
        ),
        variant: 'info',
      })
    }

    window.addEventListener(
      DEV_ANALYTICS_CUSTOM_EVENT,
      listenToDevAnalyticsEvents
    )

    return () => {
      window.removeEventListener(
        DEV_ANALYTICS_CUSTOM_EVENT,
        listenToDevAnalyticsEvents
      )
    }
  }, [showToast, setLogs])

  return null
}
